import { useEffect } from "react";
import RegistrationForm from "./RegistrationForm";

function PortalRegisterModal({
  isOpen,
  onClose,
  nextLab,
  source,
  title = "Not registered yet? Register in under 30 seconds.",
  description = "Register once and get live Zoom details, calendar invite links, and each monthly recording by email.",
  submitLabel = "Get my free invite",
}) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="portal-register-overlay" onClick={handleOverlayClick} role="presentation">
      <section className="card portal-register-modal" role="dialog" aria-modal="true">
        <button
          type="button"
          className="portal-register-close-btn"
          aria-label="Close registration"
          onClick={onClose}
        >
          X
        </button>

        <h2>{title}</h2>
        <p className="muted-copy">{description}</p>

        <RegistrationForm
          nextLab={nextLab}
          submitLabel={submitLabel}
          source={source}
        />
      </section>
    </div>
  );
}

export default PortalRegisterModal;
